import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const warehouseCredentialCreateMutationAtom = createMutationAtomFactory(
  'admin.warehouseCredentialCreate',
  (params: {
    input: {
      databaseName: string;
      username: string;
      host: string;
      port: number;
      ssl: boolean;
      enabled: boolean;
    };
    password: string;
  }) => ({
    integrationsWarehouseCredentialCreate: {
      __args: {
        input: params.input,
        password: params.password,
      },
      id: true,
      databaseName: true,
      username: true,
      host: true,
      port: true,
      ssl: true,
      enabled: true,
    },
  }),
);

export const warehouseCredentialUpdateMutationAtom = createMutationAtomFactory(
  'admin.warehouseCredentialUpdate',
  (params: {
    id: string;
    input: {
      databaseName?: string;
      username?: string;
      host?: string;
      port?: number;
      ssl?: boolean;
      enabled?: boolean;
    };
    password?: string;
  }) => ({
    integrationsWarehouseCredentialUpdate: {
      __args: {
        id: params.id,
        input: params.input,
        password: params.password,
      },
      id: true,
      databaseName: true,
      username: true,
      host: true,
      port: true,
      ssl: true,
      enabled: true,
    },
  }),
);
